import { AllTasksTabController } from './all-tasks-tab.controller'

function allTasksTab () {
  return {
    restrict: 'E',
    templateUrl: '/workflow/directives/all-tasks-tab/all-tasks-tab-directive.html?$$REVISION$$',
    controller: AllTasksTabController,
    scope: {
      isTabSelected: '<',
      isFiltering: '=',
      tabCount: '='
    }
  }
}

export { allTasksTab }
